export default {
      id: "reefer-usage",
      viewBox: "0 0 33 25",
      url: __webpack_public_path__ + "img/icons.svg#reefer",
      toString: function () {
        return this.url;
      }
    }